var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "field-input-list" }, [
    _c("div", { staticClass: "input-group" }, [
      _c(
        "div",
        {
          staticClass: "btn-group btn-group-toggle",
          attrs: { "data-toggle": "buttons" }
        },
        [
          true
            ? _c("label", { class: { "btn btn-secondary": true } }, [
                _c("input", {
                  attrs: {
                    type: "checkbox",
                    id: _vm.fieldData.field_name + "_checkbox_add"
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Add List Item")])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.fieldData.values, function(item, i) {
            return _c(
              "label",
              {
                key: i,
                class: {
                  "btn btn-primary": true,
                  active:
                    _vm.fieldData.field_value &&
                    _vm.fieldData.field_value.includes(item.internal_value)
                }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.fieldData.field_value,
                      expression: "fieldData.field_value"
                    }
                  ],
                  attrs: {
                    type: "checkbox",
                    name: _vm.fieldData.field_name,
                    id: _vm.fieldData.field_name + "_checkbox_option_" + i,
                    autocomplete: "off"
                  },
                  domProps: {
                    value: item.internal_value,
                    checked: Array.isArray(_vm.fieldData.field_value)
                      ? _vm._i(_vm.fieldData.field_value, item.internal_value) >
                        -1
                      : _vm.fieldData.field_value
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.fieldData.field_value,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = item.internal_value,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.fieldData,
                              "field_value",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.fieldData,
                              "field_value",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.fieldData, "field_value", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(item.display_value))])
              ]
            )
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52eab3eb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52eab3eb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/interactive/InputList.vue
// module id = null
// module chunks = 